import React from 'react';

const NotFound = () => <h3>Resursa căutată nu a fost găsită. Contactaţi administratorul.</h3>;

export default NotFound;